<template>
    <div class="move-icon-wrap">
        <p class="dragCtn fixed" ref="icon" @mouseover.prevent="onHover($event)" @mouseout.prevent="onOut($event)">
            <!-- @mousedown="mousedown($event)"
            @mouseup="mouseup($event)" -->
            <a class="title" v-show="!show">引导</a>
            <a class="link1" v-show="show" @click="teachFn">新手教程</a>
            <a class="link1" v-show="show" @click="linkFn(1)">帮助中心</a>
            <a class="link1" v-show="show" @click="linkFn(2)">常见问题</a>
            <a class="link1" v-show="show">API中心</a>
            <a class="link1" v-show="show" @click="openFn">需求建议</a>
            <i v-show="show" class="el-icon-s-opportunity link2"></i>
        </p>
        <div class="iframe-close-sty" v-if="showDialog" @click="showDialog = false">
            <i class="el-icon-close"></i>
        </div>
        <iframe class="iframe-sty" v-if="showDialog"
            src="https://cloud-sh.feishu.cn/share/base/form/shrcnObxBGV8bB0QuwXEq3gANQb"></iframe>
        <el-drawer class="drawer-sty" title="新手教程" :modal="false" :visible.sync="drawer" :direction="direction"
            append-to-body :before-close="handleClose">
            <el-collapse accordion v-model="activeName">
                <el-collapse-item v-for="(item,index) in collapseArr" :name="index+1">
                    <template slot="title">
                        <i class="el-icon-success1">{{(index+1)}}</i> <span>{{item.title}}</span>
                    </template>
                    <div class="content">{{item.content}}</div>
                    <a @click="toPage(item.path, item.title)">界面引导 >></a>
                </el-collapse-item>
                <!-- 

                <el-collapse-item name="1">
                    <template slot="title">
                        <i class="el-icon-success1">1</i> <span>模板领用</span>
                    </template>
                    <div class="content">从模板社区可以复制你需要的模板类型，复制完成后可前往模板管理中查看</div>
                    <a @click="toPage('/dashboard/templateCommunity', '模板领用')">界面引导 >></a>
                </el-collapse-item>
                <el-collapse-item name="2">
                    <template slot="title">
                        <i class="el-icon-success1">2</i> <span>发布模板</span>
                    </template>
                    <div class="content">前往模板管理里发布模板，只有已发布的模板才能被识别调用</div>
                    <a @click="toPage('/dashboard/template/index', '发布模板')">界面引导 >></a>
                </el-collapse-item>
                <el-collapse-item name="3">
                    <template slot="title">
                        <i class="el-icon-success1">3</i> <span>AI识别</span>
                    </template>
                    <div class="content">模板发布后，前往AI识别中上传文件进行识别</div>
                    <a @click="toPage('/dashboard/cedoc/index', 'AI识别')">界面引导 >></a>
                </el-collapse-item>
                <el-collapse-item name="4">
                    <template slot="title">
                        <i class="el-icon-success1">4</i> <span>结果导出</span>
                    </template>
                    <div class="content">勾选需要导出的数据，支持多项一起勾选</div>
                    <a @click="toPage('/dashboard/cedoc/index', '结果导出')">界面引导 >></a>
                </el-collapse-item>
                <el-collapse-item name="5" v-if="roleState && roleState === 'admin' && userType === '0'">
                    <template slot="title">
                        <i class="el-icon-success1">5</i> <span>字段管理</span>
                    </template>
                    <div class="content">如果识别有问题可以进行手动调整，首先可以手动调整需要识别的字段</div>
                    <a @click="toPage('/dashboard/field/index', '字段管理')">界面引导 >></a>
                </el-collapse-item>
                <el-collapse-item name="6">
                    <template slot="title">
                        <i class="el-icon-success1">6</i> <span>分类管理</span>
                    </template>
                    <div class="content">调整完字段后，可调整分类</div>
                    <a @click="toPage('/dashboard/classify/index', '分类管理')">界面引导 >></a>
                </el-collapse-item>
                <el-collapse-item name="7">
                    <template slot="title">
                        <i class="el-icon-success1">7</i> <span>模板管理</span>
                    </template>
                    <div class="content">最后需要调整模板</div>
                    <a @click="toPage('/dashboard/template/index', '模板管理')">界面引导 >></a>
                </el-collapse-item>
                <el-collapse-item name="8">
                    <template slot="title">
                        <i class="el-icon-success1">8</i> <span>再次AI识别</span>
                    </template>
                    <div class="content">调整结束，可回到AI识别上传文件识别，查看结果</div>
                </el-collapse-item> -->
            </el-collapse>
        </el-drawer>
    </div>
</template>

<script>
    import {
        mapState,
        mapGetters,
        mapMutations,
        mapActions,
    } from 'vuex'
    import bus from '@/assets/js/bus'
    export default {
        computed: {
            ...mapState(['labelState', "roleState", "userType"]),
        },
        data() {
            return {
                list: [
                    {
                        name: "引导",
                        index: 0,
                        x: 0,
                        y: 0
                    }
                ],
                sb_bkx: 0,
                sb_bky: 0,
                x: 0,
                y: 0,
                clientX: 0,
                clientY: 0,
                show: false,
                showDialog: false,
                drawer: false,
                direction: 'rtl',
                activeName: '1',
                collapseArr: [{
                    title: '模板领用',
                    content: '从模板社区可以复制你需要的模板类型，复制完成后可前往模板管理中查看',
                    path: '/dashboard/templateCommunity'
                }, {
                    title: '发布模板',
                    content: '前往模板管理里发布模板，只有已发布的模板才能被识别调用',
                    path: '/dashboard/template/index'
                }, {
                    title: 'AI识别',
                    content: '模板发布后，前往AI识别中上传文件进行识别',
                    path: '/dashboard/cedoc/index'
                }, {
                    title: '结果导出',
                    content: '勾选需要导出的数据，支持多项一起勾选',
                    path: '/dashboard/cedoc/index'
                }, {
                    title: '字段管理',
                    content: '在字段管理中，可以增、删、改你需要的字段',
                    path: '/dashboard/field/index'
                }, {
                    title: '分类管理',
                    content: '在分类管理中，可以增、删、改你需要的文件类型',
                    path: '/dashboard/classify/index'
                }, {
                    title: '模板管理',
                    content: '在模板管理中，可以增、删、改你需要的识别模板',
                    path: '/dashboard/template/index'
                }]
            };
        },
        created() {
            this.$nextTick(() => {
                //console.log(this.roleState, 'this.roleState1')
                //console.log(this.roleState, 'this.userType1')
                if (localStorage.getItem('BAILIAN-PD-TEMPLATE-ROLE') !== 'admin' || localStorage.getItem('BAILIAN-PD-TEMPLATE-USERTYPE') !== '0') {
                    this.collapseArr.splice(4, 1)
                }
            })
        },
        mounted() {
            bus.$on('toTeachPage', (data) => {
                this.activeName = data.toString()
                this.drawer = true
            })
        },
        methods: {
            mousedown(event) {
                this.$refs.icon.style.height = '50px'
                let that = this;
                var event = event || window.event;
                var _target = event.target;
                var startx = event.clientX;
                var starty = event.clientY;
                var sb_bkx = startx - event.target.offsetLeft;
                var sb_bky = starty - event.target.offsetTop;
                var ww = document.documentElement.clientWidth;
                var wh = window.innerHeight;
                if (event.preventDefault) {
                    event.preventDefault();
                } else {
                    event.returnValue = false;
                }

                this.clientX = event.clientX
                this.clientY = event.clientY

                document.onmousemove = function (ev) {
                    var event = ev || window.event;
                    var scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
                    if (
                        event.clientY < 0 ||
                        event.clientX < 0 ||
                        event.clientY > wh ||
                        event.clientX > ww
                    ) {
                        return false;
                    }
                    var endx = event.clientX - sb_bkx;
                    var endy = event.clientY - sb_bky;
                    _target.style.left = endx + "px";
                    _target.style.top = endy + "px";
                };
            },
            mouseup(e) {
                if (e.clientX === this.clientX && e.clientY === this.clientY) {
                    this.iconClick()
                }
                document.onmousemove = null;
            },
            iconClick() {
                this.$emit('openFn')
            },
            onHover(e) {
                this.$refs.icon.style.height = '212px'
                this.$refs.icon.style.width = '70px'
                this.show = true
            },
            onOut(e) {
                this.$refs.icon.style.height = '50px'
                this.$refs.icon.style.width = '50px'
                this.show = false
            },
            linkFn(v) {
                if (v === 1) {
                    window.open('https://cloud-sh.feishu.cn/wiki/Oe0fwUOGKiv4kvkedoQcm3sKnId?from=from_copylink', '_target')
                } else {
                    window.open('https://cloud-sh.feishu.cn/wiki/space/7277764584646443010?ccm_open_type=lark_wiki_spaceLink', '_target')
                }
            },
            openFn() {
                this.showDialog = true
            },
            teachFn() {
                this.$emit('showRight')
                this.drawer = true
            },
            handleClose() {
                this.drawer = false
            },
            toPage(v, flag) {
                if (flag === '发布模板') {
                    let url = this.$resource.listRuleTemplate
                        .replace('{pageNum}', 1)
                        .replace('{pageSize}', 10)
                        .replace('{templateType}', 1)
                    this.getUploadList(v, url, flag)
                } else {
                    if (flag === '结果导出') {
                        this.drawer = false
                        this.$store.dispatch('setDemoFlag', true);
                        this.$router.push({
                            path: '/dashboard/cedoc/index',
                            query: {
                                export: true
                            }
                        })
                    } else if (flag === '模板管理') {
                        this.drawer = false
                        this.$store.dispatch('setDemoFlag', true);
                        this.$router.push({
                            path: '/dashboard/template/index',
                            query: {
                                flag: true
                            }
                        })
                    } else {
                        this.drawer = false
                        this.$store.dispatch('setDemoFlag', true);
                        this.$router.replace(v)
                    }
                }
                this.$emit('showRight')
            },
            async getUploadList(v, url, flag) {
                await this.$axios({
                    url: url,
                    method: 'post',
                })
                    .then(res => {
                        if (res.data.data.total > 0) {
                            this.drawer = false
                            this.$store.dispatch('setDemoFlag', true);
                            this.$router.replace(v)
                        } else {
                            if (flag === '发布模板') {
                                this.$message.error('请先前往模板社区里复制模板，或者在模板管理手动新增模板')
                            }
                        }
                    })
                    .catch(e => {
                        console.log(e)
                    })
            }
        },
    };
</script>
<style>
    .move-icon-wrap {
        position: relative;
        z-index: 500;

        .ctn {
            line-height: 60px;
            cursor: pointer;
            font-size: 20px;
            text-align: center;
            float: left;
        }

        .sub:hover {
            background: #e6dcdc;
            color: white;
            width: 100px;
        }

        .ctn1 {
            width: 100px;
        }

        .sub {
            position: relative;
        }

        .fixed {
            width: 50px;
            height: 50px;
            position: fixed;
            background: #3D7FFF;
            color: #fff;
            right: 10px;
            bottom: 10px;
            cursor: pointer;
            border-radius: 60px;
            z-index: 6666;
            text-align: center;
            line-height: 50px;
            font-size: 17px;
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
            border: 3px solid #c1d6ff;
            transition: height .6s ease;
            background: linear-gradient(to right, #03a9f4, #2f89d1, #3c68bf, #326ee3);

            a.title {
                color: #f9f9f9;
                letter-spacing: 2px;
                font-size: 14px;
            }

            a.link1 {
                color: #fff !important;
                display: block;
                height: 32px;
                letter-spacing: 1px;
                font-size: 12px;

                &:hover {
                    color: #fff !important;
                    text-decoration: underline;
                }
            }

            i.link2 {
                font-size: 24px;
                color: #ffc47d;
                margin-top: 15px;
            }

            &:hover {
                border: 3px solid #c1d6ff;
                border-radius: 30px 20px 60px 60px;
                background-color: #3771e6;
            }
        }
    }

    .iframe-sty {
        position: fixed;
        bottom: 0;
        right: 0;
        width: 500px;
        height: 600px;
        z-index: 6666 !important;
        border: 3px solid #ddd;
        background-color: #f9f9f9;
        border-bottom: 0;
    }

    .iframe-close-sty {
        position: fixed;
        bottom: 575px;
        right: 0;
        background-color: #fff;
        font-size: 13px;
        height: 26px;
        box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 0 6px rgb(0 0 0 / 4%);
        line-height: 26px;
        z-index: 9999;
        width: 26px;
        color: #323232;
        text-align: center;
        cursor: pointer;
        -webkit-transition: height 1.2s ease;
        transition: height 1.2s ease;
        border: 1px solid #ddd;
        font-size: 20px;
    }
</style>